import type { InternalRequest } from '../client.js';

export interface PlatformBranding {
  brandName?: string;
  brandTagline?: string;
  brandLogoUrl?: string;
  brandColor?: string;
  [key: string]: unknown;
}

/**
 * GET /api/branding/platform is PUBLIC (no auth). Token header is harmless
 * if present — the server ignores it for this route. The login screen hits
 * this endpoint before any session exists.
 */
export function brandingEndpoints(req: InternalRequest) {
  return {
    platform: () => req.request<PlatformBranding>('/branding/platform'),
  };
}
